import { Thunk } from 'ha/myredux/types';
import { NormalizedAlgoliaListing } from 'ha/models/Listing/types';

import { Actions } from '../constants';
import { ListingEntity } from '../types';
import {
  fetchSimilarListings,
  fetchSimilarListingsFromV2,
} from '../helpers/fetchSimilarListings';

function loadSimilarListingsDone(payload: {
  similarListings: NormalizedAlgoliaListing[];
}) {
  return {
    type: Actions.LOAD_SIMILAR_LISTINGS_DONE,
    payload,
    error: false,
  };
}

const loadSimilarListings =
  (listing: ListingEntity, useSimilarListingAPI: boolean): Thunk =>
  (dispatch, _, services) => {
    const similarListingsRequest = useSimilarListingAPI
      ? fetchSimilarListingsFromV2
      : fetchSimilarListings;

    dispatch({
      type: Actions.LOAD_SIMILAR_LISTINGS_START,
      error: false,
    });

    return similarListingsRequest(listing, services)
      .then(similarListings => {
        dispatch(
          loadSimilarListingsDone({
            similarListings,
          }),
        );
      })
      .catch(() => {
        // do nothing
        // similarListings are not critical for the page
      });
  };

export { loadSimilarListings };
